"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Benefits() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const specs = [{
    stat: "100%",
    label: "DDS COMPLIANCE",
    description: "Fully qualified service provider meeting all Connecticut Department of Developmental Services standards."
  }, {
    stat: "24/7",
    label: "SUPPORT ACCESS",
    description: "Round-the-clock availability to ensure our individuals receive consistent, reliable care."
  }, {
    stat: "1:1",
    label: "PERSONALIZED CARE",
    description: "Tailored support plans designed to honor the unique goals and potential of every individual."
  }, {
    stat: "CT",
    label: "LOCAL EXPERTISE",
    description: "Deeply rooted in the Connecticut community with a focus on local advocacy and integration."
  }];
  return <section data-section-id="4072" id="employee-benefits" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1727603/img/community_support_texture.png)",
      opacity: 0.04
    }} aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none font-serif text-foreground" style={{
      fontSize: "clamp(16rem, 32vw, 32rem)",
      opacity: 0.08,
      lineHeight: 1
    }} aria-hidden="true">
        Care
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-mono text-xs md:text-sm tracking-[0.3em] text-muted-foreground uppercase mb-8">
            § 01 — OUR COMMITMENT
          </p>
          <h2 className="font-serif italic font-light leading-[0.95] tracking-tight text-foreground" style={{
          fontSize: "clamp(2.75rem, 8vw, 6rem)"
        }}>
            Stability matters.
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {}
          <div ref={imageRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative overflow-hidden rounded-lg group">
              
              <div className="absolute inset-0 bg-gradient-to-t from-background/40 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between">
                <p className="font-mono text-[10px] md:text-xs tracking-[0.25em] text-foreground/80 uppercase">
                  Service / Quality
                </p>
                <p className="font-mono text-[10px] md:text-xs tracking-[0.25em] text-foreground/80 uppercase">
                  DDS Certified
                </p>
              </div>
            </div>
          </div>

          {}
          <div ref={gridRef} className={`lg:col-span-7 transition-all duration-1000 ease-out delay-200 ${gridVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-12 md:gap-y-16">
              {specs.map((spec, i) => <div data-index={i} key={i} className="flex flex-col">
                  {}
                  <div className="h-px w-12 mb-6" style={{
                backgroundColor: "var(--chart-1)"
              }} aria-hidden="true" />

                  {}
                  <p className="font-serif font-light text-foreground leading-none mb-5" style={{
                fontSize: "clamp(2.5rem, 5vw, 4rem)"
              }}>
                    {spec.stat}
                  </p>

                  {}
                  <p className="font-mono text-[11px] md:text-xs tracking-[0.25em] text-foreground uppercase mb-3">
                    {spec.label}
                  </p>

                  {}
                  <p className="font-sans text-sm leading-relaxed text-muted-foreground max-w-xs">
                    {spec.description}
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div ref={footerRef} className={`mt-24 md:mt-32 flex items-center gap-6 md:gap-10 transition-all duration-1000 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Separator className="flex-1 bg-border" />
          <p className="font-mono text-[10px] md:text-xs tracking-[0.3em] text-muted-foreground uppercase whitespace-nowrap">
            — SERVING CONNECTICUT COMMUNITIES —
          </p>
          <Separator className="flex-1 bg-border" />
        </div>
      </div>
    </section>;
}